import { useEffect, useRef } from 'react';

import { useQueryClient } from '@tanstack/react-query';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { toast } from 'sonner';

import { userQueryKeys } from '@/entities/user';

const emailVerifiedToast = (
    <span>
        <span className="font-semibold">Email verified.</span> Thanks for helping us keep your
        Profile secured!
    </span>
);

export function useEmailVerifiedToast() {
    const { emailVerification } = useSearch({ from: '/dashboard' });
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const handledRef = useRef(false);

    useEffect(() => {
        if (emailVerification !== 'verified' || handledRef.current) return;
        handledRef.current = true;

        toast.success(emailVerifiedToast);
        void queryClient.invalidateQueries({ queryKey: userQueryKeys.emailVerificationStatus });

        // Clears the flag so a refresh doesn't replay the toast.
        void navigate({
            to: '/dashboard',
            search: (prev) => ({ ...prev, emailVerification: undefined }),
            replace: true,
        });
    }, [emailVerification, navigate, queryClient]);
}
